import { getStore } from '@/util/store'
import { operationRecord as operationRecordApi } from '@/api/index-bei-discuss'

export const operationRecord = (discussId, operation) => {
  const userInfo = getStore({ name: 'userInfo' })
  const data = {
    discussId,
    userId: userInfo.id,
    uname: userInfo.name,
    operation,
  }
  operationRecordApi(data)
}
